export default __webpack_public_path__ + "static/media/Edital_Pos_graduação 2024_2025.dc3d3196.pdf";